import {MenuItems} from 'src/app/model/menu-items.model';
import {Category} from '../cms-vod-core/category.model';

export class QueryParams {
  constructor(
    public id?: number,
    public contentName?: string,
    public contentStatus?: string[],
    public platform?: string,
    public platforms?: string[],
    public serviceType?: string[],
    public startTime?: number,
    public endTime?: number,
    public startDate?: number,
    public endDate?: number,
    public type?: string[],
    public videoOperationProcessName?: string[],
    public videoOperationProcessStatus?: string[],
    public contentGroupId?: number,
    public contentGroupIds?: number[],
    public page: number = 0,
    public pageable?: boolean,
    public itemCount?: number,
    public status?: string[],
    public promotionStatus?: string,
    public guid?: string,
    public year?: string,
    public vodType?: string[],
    public title?: string,
    public duration?: number,
    public contentType?: string,
    public actor?: string[],
    public director?: string[],
    public videoFormat?: string[],
    public aspectRatio?: string[],
    public imdbRating?: number,
    public providers?: string[],
    public pageSize?: number,
    public noActiveLicense?: boolean,
    public providerName?: string,
    public providerId?: number,
    public name?: string,
    public labelType?: string,
    public menuItemId?: number,
    public categoryId?: number,
    public menuItemIds?: number[],
    public categoryIds?: number[],
    public contentId?: number,
    public campaignId?: number,
    public userId?: number,
    public taskName?: string,
    public userName?: string,
    public licenseName?: string,
    public licenseHasContentName?: string,
    public objectId?: any,
    public statusParam?: string,
    public platformParam?: string,
    public menuItem?: MenuItems,
    public category?: Category,
    public mwInternalCode?: any,
    public channelName?: string,
    public statuses?: string[],
    public releaseDate?: string,
    public trimmed?: boolean,
    public sortType?: string,
    public validationStatus?: string,
    public validationChangeType?: string,
    public notApproved: boolean = false,
    public contentIssueType?: string,
    public issueTypeId?: number,
    public autoProcessType?: string,
    public autoProcessStatus?: string,
    public processRunType?: string,
    public channelId?: number,
    public importChannel?: string,
    public timeRangeStart?: number,
    public timeRangeEnd?: number,
    public sortParam?: string[],
    public programTitle?: string,
    public days?: string[],
    public catchupRequestStatus?: string,
    public epgProgramId?: string,
    public isHaveTrailer?: boolean,
    public planStartTime?: number[],
    public planEndTime?: number[],
    public genre?: string,
    public issueTypes?: string[],
    public surname?: string,
    public assetType?: string,
    public genreId?: number[],
    public key?: string,
    public value?: string,
    public description?: string,
    public quickFilter?: string,
    public encodingProfileName?: string,
    public encodingStationName?: string,
    public bitRate?: number,
    public videoCodec?: string,
    public videoBitRate?: number,
    public width?: number,
    public height?: number,
    public isProxy?: boolean,
    public isComingSoon?: boolean,
    public isTrailer?: boolean,
    public progressPercentage?: number,
    public check?: boolean,
    public recheck?: boolean,
    public windowStartTime?: number,
    public windowEndTime?: number,
    public action?: string,
    public actionTimeStart?: number,
    public actionTimeEnd?: number,
    public role?: string[],
    public transcodePresetName?: string,
    public presetName?: string,
    public isDeleted?: boolean,
    public startHour?: string,
    public endHour?: string,
    public startedOn?: number,
    public endedOn?: number,
    public programStartTime?: number,
    public programEndTime?: number,
    public epgRequestStatus?: string,
    public justValid?: boolean,
    public visibility?: boolean,
    public seriesName?: string,
    public seasonNo?: number,
    public episodeNo?: number
  ) {}
}
